module.exports = __webpack_public_path__ + "static/media/noyeks.accbbae7.png";